import Vue from 'vue'
import VueTreeNavigation from 'vue-tree-navigation'

Vue.use(VueTreeNavigation)
